import {make} from "vuex-pathify"
import Processes from "@/API/Processes.js"

const state = {
    isLoading: false,
    list: [],
    hasNewProcesses: 0,
}

const mutations = make.mutations(state)

const actions = {
    loading({commit}) {
        commit('SET_IS_LOADING', true)
    },
    loaded({commit}) {
        commit('SET_IS_LOADING', false)
    },
    async load({commit, dispatch}) {

        const [err, res] = await Processes.list()

        if(err) {
            console.error(err)
            return false
        }

        commit('SET_LIST', res.data?.data ?? [])

        dispatch('calcNewProcesses')

        return true
    },
    async addProcess({commit, state, dispatch}, payload) {
        commit('SET_LIST', payload)
        dispatch('calcNewProcesses')
    },
    async setProgress({commit, state, dispatch}, payload) {
        const list = state.list
        const process = list.find((item) => item.id === payload.id)
        if(process) process.progress = payload.progress
    },
    async pushNotification({commit, dispatch, state}, payload) {

        commit('SET_LIST', [...state.list, payload])
        dispatch('calcNewProcesses')

        return true
    },
    calcNewProcesses({commit, dispatch, state}){
        commit('SET_HAS_NEW_PROCESSES', state.list.filter((item) => !item.completed_at && !item.failed_at).length)
    },
    async init({commit, dispatch, state}){
        if(state.list.length) return true

        await dispatch('load')
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
